import { observable } from 'mobx'
import { Random } from 'src/commons/utils'
import CloudSaveInstance from 'src/commons/utils/CloudSave'

export { default as GameLibraryStore } from './game-library'
export { default as QueueStore } from './queue'

export const AppConfig = observable<{
  Version?: string
  WeChatLoginUnionId?: string
  PhoneCaptchaTimer: number
  PCHardwareInfo?: {
    IP: string
    MAC: string
    NetWorkMAC: string
    CPU: string
    RAM: string
    DISK: string
    GRAPH: string
    SYS: string
  }
  StartPlatformConfig: { [key in GamePlatform]?: { ErrorMsg: string; CommandLine: string } }
}>({
  PhoneCaptchaTimer: 0, //手机验证码计时器
  StartPlatformConfig: {},
  PCHardwareInfo: undefined,
})
export const WallpaperStore = observable<{
  CurrentWallpaperId: number
  WallpaperPlayStatus?: 0 | 1
  LocalWallpaperListLoading: boolean
  LocalWallpaperList: Array<WallpaperList>
  LocalWallpaperListID: number[]
}>({ CurrentWallpaperId: 0, LocalWallpaperListLoading: false, LocalWallpaperList: [], LocalWallpaperListID: [] })

export const GameDetailConfig = observable<{
  CDKGood: GameDetail | null
  RechargeGood: GameDetail | null
  AgentGood: GameDetail | null
}>({ CDKGood: null, RechargeGood: null, AgentGood: null })

export const AppStore = observable<{
  LoginModalVisible: boolean
  PhoneCaptchaTime: number
  PhoneCaptchaLoading: boolean
  PhoneCaptchaText: string
  LoginGaming: boolean
  RunningGameName?: string
  HelpVisible: boolean
  CheckModalVisible: boolean
  GameCheckStep: number
  GameCheckErrorStep: number
  GameCheckErrorStepMessage?: string //游戏检测错误步骤消息
  WeiXinLoginVisible: boolean
  WeiXinLoginTimeout: boolean
  ShowBindWeiXin: boolean
  SpeedNotifyVisible: boolean
  SpeedModalVisible: boolean
  SpeedGameName?: string
  SpeedLeftTimeVisible: boolean
  Speeding: boolean
  AreaSelected: string[]
  AreaSelectedLabel: string[]
  AutoSpeed: boolean
  NeedSpeed: boolean
  SpeedTotalTime: number
  GamePlatformInstallStatus: { [key in GamePlatform | '100']: 0 | 1 | 2 | 3 | number }
  GamePlatformUpdateStatus: 0 | 1 | 2 | 3 | number
  GamePlatformConfig: { [key in GamePlatform | '100' | '101']?: { url: string; md5: string; extend: string } }
  UninstallInfo?: { dir: string; percent: number }
  GameToolVisible: boolean
  BindMobileVisible: boolean
  LastStartGameQuery?: TLastStartGameQuery
  SaveArchiveVisible: boolean
  // NewSaveArchiveVisible: boolean
  LocalArchives: string[]
  SaveArchiveGameName?: string
  SaveArchiveGameOrderNo?: string
  GameArchiveVisible: boolean
  buyModeConfig?: {
    [key in 3 | 2 | -1]?: { tips: string; name: string; games: number[]; tips2: string; LimitGames: number[] }
  }
  BuyTypeTitle?: { [key in 'ver' | 'type']?: string }
  GamePreDownloadStatus: Array<{ GameId: number; Platform: GamePlatform; Status: 0 | 1 | 2 }>
  AgreementConfig: { [key in AgreementType]?: { title: string; content: string } }
  gameOnlineFull: {
    endtime?: string
    starttime?: string
    content?: string
    title?: string
  }
  SteamVerUplayGameInfo?: { Games: string[]; content: string }
  RefundPromiseConfig?: { content: string; description: string; logo: string; colour: string }[]
  gogFooter?: { content: string; logo: string }[]
  NotArchiveConfig?: { Games: number[]; content: string }
  ShowNewUserGift: boolean
  FWGDownloadProgress?: number
  SpeedClientInstallStatus: { [key: string]: 0 | 1 | 2 }
  SpeedClientDownloadProgress: { [key: string]: number }
  JsqConfig?: { logo: string; content: string; url: string; jump: 'in' | 'out'; newLogo: string; newUrl: string }
  cloudTimeConfig?: { bannerImg: string; target: 'in' | 'out'; outUrl: string; inUrl: string }[]
  cloudTimeTips?: string
  CMSVersion?: string
  WallpaperIn: boolean
  StartGameTimeoutConfig: { [key in GamePlatform]?: number } & { default: number }
  StartTimeoutConfig?: { newUrl: string }
  refillVisible: boolean
  currentOrderId: number
  currentOrderNo: string
  currentGameName: string
  rejectReason: string
  NotShowVerify?: string[]
  searchKey: string | undefined
  WeChatBindMobileVisible: boolean
  curVipPrice: number | string | undefined
  vipShowModal: boolean
  lastSaveTime: { [key: string]: string }
  notViewWechatEntry: string[]
  WeChatLoginData?: CheckWeiXinLogin | null
  welcomeModalVisible: boolean
  inviteModalVisible: boolean
  /** 新人礼包弹框 */
  newcomerVisisble: boolean
  /** 赠送优惠券弹框(首页自动弹出) */
  couponVisible1: boolean
  /** 赠送优惠券弹框(下单后弹出) */
  couponVisible2: boolean
  /** 首充礼包弹框 */
  firstChargeVisible: boolean

  /** 保存云存档相关 */
  newSaveArchive: {
    /**保存存档弹窗是否显示*/
    newSaveArchiveVisible: boolean
    /** 新的保存存档的名称 */
    newSaveArchiveGameName: string | null
    /** 保存存档的大小 单位字节 */
    newSaveArchiveSaveSize: number | null
    /** 保存存档订单号 */
    newSaveArchiveGameOrderNo: string | null
    /** 保存存档订ID (云游戏模式使用)*/
    newSaveArchiveSaveId: string | null
    /** 保存存档订KEY (云游戏模式使用) */
    newSaveArchiveSaveKey: string | null
    /** 游戏存档弹出框 */
    newGameArchiveVisible: boolean
    /** 客户端通知的保存存档模式 */
    newGameArchiveSaveMode: 'local' | 'cloud'
  }

  /** 云存档实例 */
  cloudSaveInstance: CloudSaveInstance | null
  /** 当前渠道支持的支付方式 */
  curPayMethod:('alipay' | 'wechat' | 'qq')[]
  /** 9+1活动弹框 */
  active1ModalVisible: boolean
  /** 第一次进入客户端，所带的游戏标识 */
  firstInGameId: null | number

  /** 第一次进入客户端，SEM推广的游戏标识 */
  semGameDetailId: null | number

  gameCenterFirstId: null | number

  /** 极速退款显示隐藏 */
  fastRefundVisible: boolean

  /** 极速退款订单 */
  fastRefundOrder: GameOrder | null

  /** 活动黑名单配置 */
  activityChannel: { key: string; channel: string }[] | null

  skinConfigs: { [props: string]: string }[]

  gameReplaceFloatVisible: boolean

  switchPayTips: { [props: string]: string }

  extractAccountVisible: boolean

  extractAccountOrder: GameOrder | null

  cdkExtractUrl: string

  listConfig: { price: string; channel: string } | null

  toolsPlatformRunningVisible: boolean

  toolsPlatformStartFailVisible: boolean

  gameUpdatedCompleted: boolean

  minimizeGameCheckVisible: boolean
  opinionList: OpinionData[]
  isShowPUBGTab: boolean
  isShowC5Tab: boolean
  vipActivityChannel: boolean
  isNewBuyWhiteChannel: string[]
  platFormProp: CDKCourse[]

  /** 右下角浮动的活动入口配置 */
  floatIconConfig: {
    img: string
    path: string
    jump: 'in' | 'out'
  } | null

  orderUpgradeText: { textUpgradeCDK: string; textUpgradeAccount: string } | null

  /** 首页礼包列表配置 */
  homePackageList: null | GamePackageList[]

  /** 反馈弹框 */
  feedbackModalVisible: boolean
  /** 反馈弹框默认填充内容 */
  feedbackModalText: string

  /** 引导是否在活动状态 */
  isActivated: boolean
  /** 游戏库第一个游戏的GameId */
  firstGameId: number | undefined
  /** 是否开启游戏库的四部引导 */
  openMyGameGuide: boolean
  CSGOIsLoadingEnd: boolean
  isFirstOpenClient: boolean
  isOpenGameCenterGuide: boolean
  gameCenterBuyGuide: boolean
  isOpenMyGameGuide: boolean
  gameBuyTypeDone: boolean
  realNameAuthModal: boolean
  artificialAuthModal: boolean
  inviteCodeModal: boolean
  bindInvitationCodeSuccessModal: boolean
  bindResult: {
    discount: number
    inviteeGivingVipDays: number
    inviterGivingVipDays: number
    beInviteeGivingVipDays: number
    beInviterGivingVipDays: number
  } | null
  anchorConfig: { ids?: string; qq?: string; rules?: string; discount?: string; gamesNum?: string }
  viewFastRefundIds: string[]
  startPageRefundConfig: boolean
  discountDescriptionVisible: boolean
  fastRefundFinalVisible: boolean
  PUBGBannerConfig: { imgUrl: string; targetUrl: string; viewIds: string; newUrl: string } | null
  buyPromiseConfig: { notSupportTypes: string[]; img: string; title: string; description: string }[] | null
  chargeDepositVisible: boolean
  currentChargeDepositGameId: number | null
  /** 云存档下载完成 */
  downComplete: number
  /** 存档保存成功 */
  saveComplete: number
  /** 启动游戏前的下载云存档进度 */
  archivesProgressObj: {
    key: string
    total?: number
    current?: number
  } | null
  /** 多个云存档下载进度 */
  archivesProgressObjMap: Map<
    string,
    {
      key: string
      total: number
      current: number
      complete?: boolean
    }
  >
  viewBBSIds: string[]
  accountTypeDescription: TAccountTypeDescription | null
  accountDescriptionConfig: TAccountDescriptionConfig[] | null
  /** 当前播放的视频 */
  currentPlayVideo: HTMLVideoElement | null
  startHelpConfig: TStartHelpConfig | null
  editorPostsData: TBBSListItem | null
  bindingCloudGameTime: string
  /** 全局共享QQ群配置信息 */
  QQConfig: {
    GameQQlink: string
    GameQQnumber: string
    GameQQnumberpic: string
  } | null
  // 移动端下载地址
  mobileDownload: string | undefined
  /** 窗口状态 status: 0 - 窗口模式  1 - 最大化  2 - 全屏模式 */
  windowStatus: 0 | 1 | 2
  //双12活动群
  active12Code: string | undefined
  //底部的下载广告是否显示
  bottomDownloadShow: boolean
  /** 绑定推荐人弹框 */
  bindReferrerVisible: boolean
  /** 显示云游戏反馈弹窗 */
  cloudGameFeedBackVisible: boolean
  standbyHelp: boolean
  modalVisibleList: Array<'archive' | 'feedback' | 'success'>
  isLoadC5: boolean
  /** 首页优惠券悬浮窗 */
  couponTagVisible: boolean
  /** 登陆成功后，购买后，启动游戏前，实名认证弹框是否显示 */
  authSwitchConfig: {
    loginFlag: boolean
    buyFlag: boolean
    startFlag: boolean
  }
  closealoneSwitchConfig: boolean
  closeAloneSwitchwhiteList: string[]
  leaveConfirmVisible: boolean
  refundCommunity: { title: string; img: string; desc: string[] } | null
  buySuccessCommunity: { title: string; img: string; desc: string[] } | null
  startCommnunity: { title: string; img: string; desc: string[] } | null
  startProblemVisible: boolean
    }>({
      startProblemVisible: false,
      refundCommunity: null,
      buySuccessCommunity: null,
      startCommnunity: null,
      bindResult: null,
      bindInvitationCodeSuccessModal: false,
      standbyHelp: false,
      accountDescriptionConfig: null,
      accountTypeDescription: null,
      currentChargeDepositGameId: null,
      chargeDepositVisible: false,
      buyPromiseConfig: null,
      orderUpgradeText: null,
      PUBGBannerConfig: null,
      fastRefundFinalVisible: false,
      startPageRefundConfig: false,
      viewFastRefundIds: [],
      discountDescriptionVisible: false,
      homePackageList: null,
      floatIconConfig: null,
      toolsPlatformStartFailVisible: false,
      toolsPlatformRunningVisible: false,
      minimizeGameCheckVisible: false,
      gameUpdatedCompleted: false,
      cdkExtractUrl: '',
      listConfig: null,
      extractAccountOrder: null,
      extractAccountVisible: false,
      switchPayTips: {},
      gameReplaceFloatVisible: false,
      skinConfigs: [],
      fastRefundVisible: false,
      fastRefundOrder: null,
      activityChannel: null,
      active1ModalVisible: false,
      curPayMethod: ['alipay', 'wechat', 'qq'],
      LoginModalVisible: false, //是否显示登录框
      PhoneCaptchaTime: 120, //手机验证码倒计时时长
      PhoneCaptchaLoading: false, //是否正在获取验证码
      PhoneCaptchaText: '获取验证码', //验证码按钮文本
      LoginGaming: false,
      HelpVisible: false, //游戏帮助弹出框
      CheckModalVisible: false,
      GameCheckStep: 0, //游戏检测步骤
      GameCheckErrorStep: -1, //游戏检测错误步骤
      WeiXinLoginVisible: false, //微信登录弹出框
      WeiXinLoginTimeout: false, //微信登录超时弹出框
      ShowBindWeiXin: false, //是否显示绑定微信
      SpeedNotifyVisible: false,
      SpeedModalVisible: false,
      SpeedLeftTimeVisible: false,
      Speeding: false,
      AreaSelected: [],
      AreaSelectedLabel: [],
      AutoSpeed: localStorage.getItem('AutoSpeed') !== 'false',
      NeedSpeed: false,
      SpeedTotalTime: 0,
      GamePlatformInstallStatus: { 1: 0, 2: 0, 4: 0, 5: 0, 6: 0, 100: 0, 9: 0, 99: 0 },
      GamePlatformConfig: {},
      GamePlatformUpdateStatus: 0,
      GameToolVisible: false,
      BindMobileVisible: false,
      SaveArchiveVisible: false,
      // NewSaveArchiveVisible: true,
      LocalArchives: [],
      GameArchiveVisible: false,
      GamePreDownloadStatus: [],
      AgreementConfig: {},
      gameOnlineFull: {},
      ShowNewUserGift: !localStorage.getItem('ShowedNewUserGift'),
      SpeedClientInstallStatus: {},
      SpeedClientDownloadProgress: {},
      WallpaperIn: false,
      StartGameTimeoutConfig: { default: 120 },
      searchKey: '',
      WeChatBindMobileVisible: false,
      curVipPrice: 0,
      refillVisible: false,
      currentOrderId: 0,
      currentOrderNo: '',
      currentGameName: '',
      newcomerVisisble: false,
      vipShowModal: false,
      rejectReason: '',
      lastSaveTime: {},
      notViewWechatEntry: [],
      WeChatLoginData: null,
      welcomeModalVisible: false,
      inviteModalVisible: false,
      isNewBuyWhiteChannel: [],
      newSaveArchive: {
        /**保存存档弹窗是否显示*/
        newSaveArchiveVisible: false,
        /** 新的保存存档的名称 */
        newSaveArchiveGameName: null,
        /** 保存存档的大小 单位字节 */
        newSaveArchiveSaveSize: null,
        /** 保存存档订单号 */
        newSaveArchiveGameOrderNo: null,
        /** 保存存档订ID (云游戏模式使用)*/
        newSaveArchiveSaveId: null,
        /** 保存存档订KEY (云游戏模式使用) */
        newSaveArchiveSaveKey: null,
        /** 游戏存档弹出框 */
        newGameArchiveVisible: false,
        /** 客户端通知的保存存档模式 */
        newGameArchiveSaveMode: 'local',
      },

      /** 云存档实例 */
      cloudSaveInstance: null,
      opinionList: [],
      /** 是否展示PUBG专区Tab */
      isShowPUBGTab: false,
      /** 平台&游戏cdk使用帮助图片 */
      platFormProp: [],
      /** 反馈弹框 */
      feedbackModalVisible: false,
      /** 反馈弹框默认填充内容 */
      feedbackModalText: '',
      /** 是否展示C5游戏开箱Tab */
      isShowC5Tab: false,
      /** 根据渠道黑名单是否展示vip活动， 默认不在黑名单中 true, 展示 */
      vipActivityChannel: true,
      /** 是否正在引导模式 */
      isActivated: false,
      /** CSGO开箱请求是否加载完毕, 以免影响侧边栏的游戏库引导高亮位置, 默认true加载结束 */
      CSGOIsLoadingEnd: true,
      /** 游戏库的第一款游戏ID, 需要用在游戏库第二步引导中跳转到游戏启动界面 */
      firstGameId: undefined,
      /** 是否开启游戏库的第 三 四步引导 */
      openMyGameGuide: false,
      /* 是否开启游戏库引导 */
      isOpenMyGameGuide: false,
      /** 有没有客户端的购买标识 */
      firstInGameId: null,
      /** sem推广页下载的客户端 */
      semGameDetailId: null,
      /** 是否第一次打开客户端， 默认不是第一次打开 */
      isFirstOpenClient: false,
      /** 是否开启游戏中心引导 */
      isOpenGameCenterGuide: false,
      /** 游戏中心游戏列表第一个的 游戏的product ID */
      gameCenterFirstId: null,
      /** 剩余游戏中心三四步指导开启 */
      gameCenterBuyGuide: false,
      /** 游戏类型加载完毕 */
      gameBuyTypeDone: false,
      /** 实名认证弹框 */
      realNameAuthModal: false,
      /**人工认证弹框 */
      artificialAuthModal: false,
      /** 云存档下载完成 */
      downComplete: 0,
      /** 存档保存宝成 */
      saveComplete: 0,
      archivesProgressObj: null,
      archivesProgressObjMap: new Map(),
      /**邀请码弹框 */
      inviteCodeModal: false,
      /** 主播相关配置 */
      anchorConfig: {},
      viewBBSIds: [],
      currentPlayVideo: null,
      startHelpConfig: null,
      editorPostsData: null,
      bindingCloudGameTime: '',
      QQConfig: null,
      mobileDownload: undefined,
      windowStatus: 0,
      active12Code: undefined,
      firstChargeVisible: false,
      bottomDownloadShow: !window.FuluApp,
      bindReferrerVisible: false,
      cloudGameFeedBackVisible: false,
      modalVisibleList: [],
      couponVisible1: false,
      couponVisible2: false,
      isLoadC5: false,
      couponTagVisible: false,
      authSwitchConfig: {
        loginFlag: false,
        buyFlag: true,
        startFlag: true,
      },
      closealoneSwitchConfig: false,
      closeAloneSwitchwhiteList: [],
      leaveConfirmVisible: false,
    })
export const HaiShaJsqStore = observable<{
  JsqRunning: boolean
  gameId?: number
  areaInfo?: JsqAreaInfo
  jsTime: number
}>({
  JsqRunning: false,
  gameId: undefined,
  areaInfo: undefined,
  jsTime: 0,
})

class Store {
  @observable
  isInClient: boolean = !!window.FuluApp

  @observable
  /** 协议弹框开关 */
  protocolVisible: boolean = false

  @observable
  /** 当前协议类型 */
  protocolType: AgreementType | null = null

  @observable
  /** 控制页面刷新 */
  refresh: boolean = false
}

export default new Store()
